import React, { useState } from "react";
import PropTypes from 'prop-types';

import PageTitle from "../components/common/PageTitle";
import ImagePanel from "../components/user-profile-lite/ImagePanel";
import {
  Container,
  Card,
  CardHeader,
  ListGroup,
  ListGroupItem,
  Row,
  Col,
  Form,
  FormGroup,
  FormInput,
  FormSelect,
  FormTextarea,
  Button
} from "shards-react";

async function loginUser(credentials) {
  const DD_API_HOST = process.env.REACT_APP_DD_API_HOST;
  return fetch(DD_API_HOST+'/dd_ap_oauth?tok=dd_ap_5143133231', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(credentials)
  })
    .then(data => data.json())
}

// const Login = ({setToken}) => (
function Login({setToken}) {
  const [username, setUserName] = useState();
  const [password, setPassword] = useState();
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async e => {
    e.preventDefault();
    const token = await loginUser({
      username,
      password
    });
    if (token.hasOwnProperty('err'))
      setErrorMsg(token.err);
    else
      setToken(token);
  }

  return (
  <Container fluid className="main-content-container px-4">
    <Row noGutters className="page-header py-4">
      <PageTitle title="DW Digest" subtitle="Welcome to" md="12" className="ml-sm-auto mr-sm-auto" />
    </Row>
    <Row>
      <Col lg="8">
        <ImagePanel />
      </Col>
      <Col lg="4">
        <Card small className="mb-4">
          <CardHeader className="border-bottom">
            <h6 className="m-0">Sign In</h6>
          </CardHeader>
          <ListGroup flush>
            <ListGroupItem className="p-3">
              <Row>
                <Col>
                  <Form onSubmit={handleSubmit}>
                    <Row form>
                      {/* Email */}
                      <Col md="12" className="form-group">
                        <label htmlFor="feEmail">Email</label>
                        <FormInput
                          type="email"
                          id="feEmail"
                          placeholder="Email Address"
                          // value="sierra@example.com"
                          onChange={e => setUserName(e.target.value)}
                          // autoComplete="email"
                        />
                      </Col>
                    </Row>
                    <Row form>
                      {/* Password */}
                      <Col md="12" className="form-group">
                        <label htmlFor="fePassword">Password</label>
                        <FormInput
                          type="password"
                          id="fePassword"
                          placeholder="Password"
                          // value="EX@MPL#P@$$w0RD"
                          onChange={e => setPassword(e.target.value)}
                          // autoComplete="current-password"
                        />
                      </Col>
                    </Row>
                    <Button type="submit" theme="accent">Sign In</Button>
                    <span>&nbsp;&nbsp;{errorMsg}</span>
                  </Form>
                </Col>
              </Row>
            </ListGroupItem>
          </ListGroup>
        </Card>
      </Col>
    </Row>
    <Row noGutters className="page-header py-4">
      <Card className="pl-3 pt-2 pr-3">
        <p>Copyright (c) 2021 nextCoder - DWDigest.com. All rights reserved.</p>
      </Card>
    </Row>
  </Container>
  );
}

Login.propTypes = {
  setToken: PropTypes.func.isRequired
}

export default Login;
